import { AppProvider, Source } from '@aura/contextos-frontend';
import { useTheme } from '@aura/temas-frontend/dist/contexts/theme/theme.hook';
import { lazy, useCallback, useEffect, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Head } from '../../components/head';
import { Page } from './Bootstrap.types';

const ErrorBoundary = lazy(() =>
  import('../../components/error-boundary/error-boundary').then((m) => ({ default: m.ErrorBoundary })),
);
const App = lazy(() => import('../app/app'));

export const Bootstrap: Page = ({ environment, onLoading, onError }) => {
  const { setTheme } = useTheme();

  const configSource = useCallback((): Source => {
    const { marca, contextos, ...data } = environment;
    return {
      contexts: contextos,
      brand: marca,
      domain: 'aluno',
      entries: Object.freeze({ ...data }),
    };
  }, [environment]);

  useEffect(() => {
    setTheme(environment.marca);
  }, [setTheme, environment]);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const loginHint = query.get('login_hint');
    if (loginHint) {
      sessionStorage.setItem('login_hint', loginHint);
    }
    const forceLogin = query.get('force_login');
    if (forceLogin) {
      sessionStorage.setItem('force_login', `${forceLogin == 'true'}`);
    }
  }, []);

  return useMemo(
    () => (
      <AppProvider configSource={configSource} onLoading={onLoading} onError={onError}>
        <ErrorBoundary>
          <Head />
          <BrowserRouter>
            <App onLoading={onLoading} />
          </BrowserRouter>
        </ErrorBoundary>
      </AppProvider>
    ),
    [configSource, onError, onLoading],
  );
};

export default Bootstrap;
